import { Injectable } from "@angular/core";
import { ApiService } from "clearline-api";

@Injectable()
export class DataService extends ApiService {}
